import clsx from 'clsx';
import { forwardRef, PropsWithChildren } from 'react';
import { BaseButton, BaseButtonProps } from './base-button';

export interface FilledButtonProps extends BaseButtonProps {
  variant: 'filled';
  color?: 'primary' | 'danger';
}

export const FilledButton = forwardRef<HTMLButtonElement, PropsWithChildren<FilledButtonProps>>(
  ({ children, disabled, className, isLoading, color = 'primary', ...rest }, ref) => {
    return (
      <BaseButton
        ref={ref}
        isLoading={isLoading}
        className={clsx(
          {
            'bg-green-laser text-green-dark hover:text-green-laser hover:bg-black active:bg-green-forest active:border-2 active:border-green-laser active:text-green-laser':
              !disabled && color === 'primary',
            'bg-red-bright text-white hover:bg-red-500 focus:bg-red-500 active:bg-green-forest active:border-2 active:border-red-bright active:text-red-bright':
              !disabled && color === 'danger',
            'bg-green-dark text-gray-medium border-gray-medium border-2 pointer-events-none opacity-30': disabled,
            'bg-green-forest border-green-laser text-green-laser border-2 focus:bg-green-dark': isLoading,
          },
          className
        )}
        {...rest}
        disabled={disabled}
      >
        {children}
      </BaseButton>
    );
  }
);
